import React from 'react';
import { Link } from 'react-router-dom';
import buttonStyles from '../Button/Button.module.css';
import styles from './ButtonLink.module.css';

const VARIANT_CLASS = {
    primary: 'primary',
    outline: 'outline',
    secondary: 'secondary',
    success: 'success',
    danger: 'danger',
    text: 'text',
    gold: 'gold',
};

export default function ButtonLink({
    variant = 'primary',
    to,
    children,
    className,
    ...rest
}) {
    const variantKey = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;

    return (
        <Link
            to={to}
            className={`${buttonStyles.button} ${buttonStyles[variantKey]} ${styles.link} ${styles[variantKey]} ${className || ''}`}
            {...rest}
        >
            {children}
        </Link>
    );
}
